"use client";

import { useEffect } from "react";

/**
 * Root error boundary. Catches errors thrown in the root/locale layout tree
 * (above the segment `error.tsx`), which is exactly the case that otherwise
 * renders Next's bare "Application error" page. Reports the real error to the
 * server so we can see the message/stack/digest, then shows a minimal fallback.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    try {
      const body = JSON.stringify({
        kind: "global-error",
        message: error?.message ?? "",
        stack: error?.stack ?? null,
        digest: error?.digest ?? null,
        url: typeof window !== "undefined" ? window.location.href : "",
      });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(
          "/api/client-error",
          new Blob([body], { type: "application/json" }),
        );
      } else {
        void fetch("/api/client-error", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body,
          keepalive: true,
        });
      }
    } catch {
      // ignore
    }
  }, [error]);

  return (
    <html>
      <body
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, sans-serif",
          padding: "24px",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 480 }}>
          <h1 style={{ fontSize: 22, marginBottom: 12 }}>
            حدث خطأ غير متوقع
          </h1>
          <p style={{ color: "#666", marginBottom: 20 }}>
            نعتذر، تعذّر تحميل الصفحة. حاول إعادة التحميل.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              padding: "10px 20px",
              borderRadius: 8,
              border: "none",
              background: "rgb(7,55,99)",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            إعادة المحاولة
          </button>
        </div>
      </body>
    </html>
  );
}
